const LEAVE_FORM_FIELDS = `
  id
  contact_id
  group_movement_id
  poll_id
  status_id
  token
  submitted_at
  interviewer_comment
  its
  uts
  status {
    id
    name
    position
  }
  answers {
    id
    form_id
    question_id
    text
    choice_ids
  }
`;

export const CREATE_LEAVE_FORM = `
  mutation createLeaveForm($tenant_id: Int!, $input: CreateLeaveFormInput!) {
    createLeaveForm(tenant_id: $tenant_id, input: $input) {
      __typename
      ... on LeaveForm {
        ${LEAVE_FORM_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SUBMIT_LEAVE_FORM_BY_TOKEN = `
  mutation submitLeaveFormByToken($token: String!, $input: SubmitLeaveFormInput!) {
    submitLeaveFormByToken(token: $token, input: $input) {
      __typename
      ... on LeaveForm {
        ${LEAVE_FORM_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
